import { Button, HStack, Icon, Image, Text, VStack } from '@chakra-ui/react';
import iconFileXLSX from 'assets/icons/icon-file-xlsx.svg';
import IconSelectBoxCircle from 'assets/icons/icon-select-box-circle.svg?react';
import IconUploadCloud from 'assets/icons/icon-upload-cloud.svg?react';
import numeral from 'numeral';
import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import ButtonRemove from './ButtonRemove';

interface UploadFileProps {
  onChange: (file: any) => void;
  accept: any;
  description: string;
  hideButton?: boolean;
}

export default function UploadFile({ onChange, accept, description, hideButton }: UploadFileProps) {
  const [file, setFile] = useState<any>();

  const onDrop = useCallback(acceptedFiles => {
    const file = acceptedFiles[0];
    setFile(file);
    onChange(file);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop, 
    accept
  });

  if (file) {
    return (
      <HStack
        p="16px"
        spacing="12px"
        borderRadius="12px"
        border="1px solid #E1E4EA"
        minH="100px"
      >
        <Image src={iconFileXLSX} />
        <VStack alignItems="flex-start">
          <Text as="span" fontWeight={500}>{file.name}</Text>
          <HStack
            fontSize="12px"
            spacing="3px"
          >
            <Text as="span" color="#525866">{numeral(file.size).format('0b')}</Text>
            <Icon as={IconSelectBoxCircle} ml="10px" />
            <Text as="span">Enviado</Text>
          </HStack>
        </VStack>
        <ButtonRemove 
          clean
          ml="auto"  
          onClick={() => {
            setFile(null);
            onChange(null);
          }} />
      </HStack>
    );
  }

  return (
    <VStack 
      {...getRootProps()}
      borderRadius="12px"
      border="1px dashed #CACFD8"
      spacing="20px"
      p="32px"
      cursor="pointer"
      minH="150px"
    >
      <input {...getInputProps()} />
      <IconUploadCloud />
    { isDragActive ?
      <Text>Solte o arquivo aqui</Text> :
      <Text textAlign="center">
        <strong>Escolha ou arraste um arquivo</strong><br />
        {description}
      </Text>
    }
      { !hideButton && <Button>Selecionar arquivo</Button> }
    </VStack>
  );
}
